import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import IconTransform from "../iconsElement";

import { Fragment } from "react";
import {
  Dns,
  LocalOffer,
  PlaceOutlined,
  StorageOutlined,
} from "@mui/icons-material";

const interfacesType = {
  1: "Agent",
  2: "SNMP",
  3: "IPMI",
  4: "JMX",
};

export default function ElementHeader(props) {
  const {
    titulo,
    interfaces,
    tags,
    img,
    coordenadas,
    fonte,
    tipo,
    mapa,
    size,
    setSnackbar = () => {},
  } = props;
  const theme = useTheme();

  const styles = {
    retangle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "primary.main",
      paddingX: "5px",
      maxWidth: "30px",
      clipPath: "polygon(25% 0, 100% 0, 100% 75%, 75% 100%, 0 100%, 0 25%)",
    },
    text: { fontSize: "0.8em" },

    retangleText: { fontSize: "0.6em", color: "white" },
    elementName: {
      fontSize: "1em",
      textAlign: "left",
      mb: -0.4,
      cursor: "pointer",
    },
    icon: {
      mx: size == "small" ? "0px" : "15px",
    },
    stackElement: {
      paddingY: "15px",
      justifyContent: "start",
      alignItems: "center",
      with: "100%",
      fontWeight: 400,
    },
  };
  //verificacao de tag (verifica se existe tag de fabricante, funcao ou modelo)
  const verificaTag = () => {
    if (!tags) return;
    return tags?.some((item) => {
      if (
        item.tag == "fabricante" ||
        item.tag == "funcao" ||
        item.tag == "modelo"
      )
        return true;
    });
  };
  const agrupaTags = () => {
    if (!tags && !verificaTag()) return;
    let fabricante = "",
      funcao = "",
      modelo = "";
    tags?.map(({ tag, value }) => {
      if (tag == "fabricante") fabricante = value;
      if (tag == "funcao") funcao = value?.split("-")[1];
      if (tag == "modelo") modelo = value?.split("-")[2];
    });
    if (!fabricante && !funcao && !modelo) return;
    return `${fabricante} - ${funcao} - ${modelo}`;
  };

  return (
    <Stack direction={"row"} sx={styles.stackElement}>
      <Stack alignItems="center" sx={styles.icon}>
        <IconTransform
          img={img}
          size="35px"
          color={theme.palette.color.icons}
        />
        {tipo != 0 && (
          <Box sx={styles.retangle}>
            <Typography sx={styles.retangleText}>
              {mapa?.tipo == 0 ? "Geo" : "Top"}
            </Typography>
          </Box>
        )}
        {tipo == 0 &&
          interfaces?.map((inter, index) => (
            <Box sx={styles.retangle} key={"inter" + index}>
              <Typography sx={styles.retangleText}>
                {interfacesType[inter.type]}
              </Typography>
            </Box>
          ))}
      </Stack>
      <Stack>
        <Tooltip
          title={titulo}
          onClick={() => {
            navigator.clipboard.writeText(titulo);
            setSnackbar({
              children: "Título copiado!",
              severity: "info",
            });
          }}
        >
          <Typography sx={styles.elementName}>
            {titulo?.length > 30
              ? titulo.substring(0, 30)?.toLocaleUpperCase() + "..."
              : titulo?.toLocaleUpperCase()}
          </Typography>
        </Tooltip>

        {tipo != 0 && (
          <>
            <Stack direction={"row"} gap={1} alignItems="center">
              <Typography color={theme.palette.text.disabled} variant="small">
                {mapa?.Element?.length} Elemento(s)
              </Typography>
            </Stack>
          </>
        )}
        {tipo == 0 && (
          <>
            {tags && verificaTag() && (
              <Stack direction={"row"} gap={0.5} alignItems="center">
                <LocalOffer
                  sx={{
                    fontSize: "0.95rem",
                    color: theme.palette.text.disabled,
                  }}
                />
                <Typography variant="small" color={theme.palette.text.disabled}>
                  {agrupaTags()}
                </Typography>
              </Stack>
            )}
            <Stack direction={"row"} gap={1}>
              {interfaces?.map((inter, index) => (
                <Stack gap={0.5} direction="row" key={"inter" + index}>
                  <Dns
                    sx={{
                      fontSize: "0.95rem",
                      color: theme.palette.text.disabled,
                    }}
                  />
                  <Typography
                    color={theme.palette.text.disabled}
                    variant="small"
                  >
                    {inter.ip}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </>
        )}
        {coordenadas && (
          <Stack
            direction="row"
            alignItems="center"
            gap={0.5}
            sx={{ color: "text.disabled", fontSize: "0.75rem" }}
          >
            <PlaceOutlined sx={{ fontSize: "0.95rem" }} />
            <Typography variant="caption" color="text.disabled">
              {coordenadas}
            </Typography>
          </Stack>
        )}
        {/* De qual fonte a linha veio (um dos cards de `erpBancos`). O rótulo é o
            host, porque o identificador completo é longo — ele fica no tooltip e
            no clique, que copia. */}
        {fonte?.rotulo && (
          <Tooltip title={fonte.completo || fonte.rotulo}>
            <Stack
              direction="row"
              alignItems="center"
              gap={0.5}
              onClick={() => {
                navigator.clipboard.writeText(fonte.completo || fonte.rotulo);
                setSnackbar({
                  children: "Fonte copiada!",
                  severity: "info",
                });
              }}
              sx={{
                color: "text.disabled",
                fontSize: "0.75rem",
                cursor: "pointer",
              }}
            >
              <StorageOutlined sx={{ fontSize: "0.95rem" }} />
              <Typography variant="caption" color="text.disabled">
                {fonte.rotulo}
              </Typography>
            </Stack>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}
